import { useQuery } from "@tanstack/react-query";
import { download } from "../../api/client";
import type { RoadDetail } from "../../api/types";
import { Icon } from "../../components/Icon";
import { Panel } from "../../components/Layout";
import { QueryState, SkeletonBlock } from "../../components/States";

export function ReportTab({ road }: { road: RoadDetail }) {
  const sid = road.survey.survey_uuid;
  const url = (f: string) => `/api/reports/road/${sid}?format=${f}`;
  const preview = useQuery({
    queryKey: ["road", sid, "report-html"],
    queryFn: async () => {
      const r = await fetch(`${url("html")}&preview=true`, { credentials: "same-origin" });
      if (!r.ok) throw new Error("The report preview could not be generated.");
      return r.text();
    },
  });

  return (
    <div className="split">
      <Panel title="Preview" id="rp-preview">
        <QueryState query={preview} skeleton={<SkeletonBlock rows={10} />}>
          {(html) => <iframe title="Report preview" srcDoc={html} sandbox="" style={{ width: "100%", height: 640, border: "1px solid var(--line)", borderRadius: 8, background: "#fff" }} />}
        </QueryState>
      </Panel>
      <Panel title="Download" id="rp-download">
        <div className="stack">
          <button className="btn btn-primary" onClick={() => download(url("xlsx"))}><Icon name="download" />Excel workbook</button>
          <p className="muted" style={{ fontSize: 13 }}>Sheets: road summary, verified findings, AI candidates – not verified, condition sections and asset inventory.</p>
          <button className="btn" onClick={() => download(url("html"))}><Icon name="download" />HTML report</button>
          <p className="muted" style={{ fontSize: 13 }}>The report shown here, as a file you can open, print or attach.</p>
          <button className="btn" onClick={() => download(url("csv"))}><Icon name="download" />Findings CSV</button>
          <p className="muted" style={{ fontSize: 13 }}>One row per finding, with its status, for GIS or your own analysis.</p>
        </div>
      </Panel>
    </div>
  );
}
